import { render, staticRenderFns } from "./Data8Search.vue?vue&type=template&id=f66d9ed8"
import script from "./Data8Search.vue?vue&type=script&lang=ts"
export * from "./Data8Search.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports